import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Database, BarChart3, Bell, Shield, Monitor, Settings } from 'lucide-react';

const Platform = ({ onRequestDemo }) => {
  const modules = [
    { icon: Database, title: 'Analytics engine', desc: 'Rules, detections, thresholds—configured to your environment.' },
    { icon: Monitor, title: 'Dashboards & reporting', desc: 'Clear oversight for teams and leadership. Multi-site ready.' },
    { icon: Bell, title: 'Alerts & workflows', desc: 'Escalation, acknowledgement, audit trail, consistent response.' },
    { icon: Shield, title: 'Evidence & governance', desc: 'Access control, event history, operational traceability.' },
    { icon: Settings, title: 'Deployment flexibility', desc: 'Edge / on-prem / cloud-ready options depending on constraints.' }
  ];

  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-[var(--accent-wash)] to-transparent">
        <div className="max-w-6xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="heading-1 mb-6">A modular platform for analytics, alerts, and operational visibility.</h1>
            <p className="body-large text-[var(--text-secondary)] max-w-3xl mx-auto mb-8">
              Built to integrate, deploy, and scale across real environments.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={onRequestDemo} className="btn-primary">Request a Demo</button>
              <Link to="/contact" className="btn-secondary">Talk to an Expert</Link>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="heading-2 text-center mb-12">Platform modules</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {modules.map((module, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="product-card">
                <module.icon className="w-10 h-10 text-[var(--accent-primary)] mb-4" />
                <h3 className="heading-3 mb-3">{module.title}</h3>
                <p className="text-[var(--text-secondary)]">{module.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-2 mb-6">See how the platform fits your environment—and what we'd deploy first.</h2>
          <button onClick={onRequestDemo} className="btn-primary">Request a Demo</button>
        </div>
      </section>
    </div>
  );
};

export default Platform;